<template>
    <Navbar></Navbar>
    <div class="page-box">
        <div class="img-box page-banner">
            <img data-src="/assets/manufacture/transmission/pizhou/pz.jpg" alt=""></img>
            <div class="title-box">
                <div class="manufacture-t1">
                    Pizhou Transmission Plant
                </div>
                <div class="manufacture-t2">
                    Located in Pizhou, Xuzhou, Jiangsu Province, the company mainly produces DHT‑1, DHT‑2, DHT‑3, DHT‑3L and 150kW electric axle assemblies.<br />
                    As a key component manufacturer, it masters core technologies covering the entire powertrain spectrum—from conventional power and hybrid power to pure electric power (including controllers)—as well as automotive intelligent integrated systems. Its product portfolio includes conventional DCT and AT transmissions, dedicated hybrid transmissions, and pure electric drive assemblies.<br />
                </div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                DHT4 Line
            </div>
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    
                    <div class="swiper-slide">
                        <div class="text-box ">
                            <div class="title">
                                Motor shrink fitting
                            </div>
                            <div class="destils">
                                ① The motor adopts the shrink fitting process.<br />
                                ② The housing is heated to 150°C by medium-frequency induction heating. The robot accurately grasps the stators of the two motors and places them into the housing. After cooling down to room temperature by air conditioning, the housing tightly holds the motors, achieving the stator fixing function.
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/pizhou/pz1-1.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="text-box ">
                            <div class="title">
                                Automatic Loading & Assembly
                            </div>
                            <div class="destils">
                                The automated loading of housing locating pins, oil seals, bolts and other components is realized through automatic bins. Robots on the equipment automatically complete the loading and assembly.
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/pizhou/pz1-2.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="text-box ">
                            <div class="title">
                                EOL Test
                            </div>
                            <div class="destils">
                                ① Adopts a fully automatic EOL test bench to conduct comprehensive functional and safety tests covering mechanics, motor, electrics, software, NVH, and control strategies. This ensures smooth and quiet operation of the engine transmission section, as well as the safety and reliability of the electric drive section.<br />
                                ② Before each transmission assembly leaves the factory, the test equipment fully simulates the engine and vehicle driving conditions, and performs 100% full-function and full-item testing including NVH test.<br />
                                ③ Adopts the state-of-the-art Discom test system for analysis and judgment, ensuring the delivery of safe, reliable and high-quality products to customers.
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/pizhou/pz1-3.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="text-box ">
                            <div class="title">
                                Line Transfer & Laser Marking
                            </div>
                            <div class="destils">
                                ① Adopts high-position robots and laser marking technology.<br />
                                ② The robot grasps the transmission from the truss roller conveyor and transfers it to the laser marking machine for marking. An oil mist collection system is equipped to absorb and filter smoke and dust, ensuring product cleanliness and quality.
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/pizhou/pz1-4.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="text-box ">
                            <div class="title">
                                Motor Line Transfer & Clutch Housing Automatic Assembly
                            </div>
                            <div class="destils">
                                ① Adopts the process of motor line transfer and automatic clutch housing assembly.<br />
                                ② Materials are placed by trolleys at the line side. The 3D camera above identifies the precise position of components and sends data to the robot. The robot then accurately grasps the materials to complete automatic assembly, completely eliminating the labor intensity of manual housing handling.
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/pizhou/pz1-5.jpg" alt="">
                        </div>
                    </div>
                    
                    <div class="swiper-slide">
                        <div class="text-box ">
                            <div class="title">
                                Shaft System Automatic Assembly
                            </div>
                            <div class="destils">
                                The automatic assembly station on the shaft line automatically splices the shaft stack by fixture positioning.
                                Two robots work collaboratively to grasp components, achieving precise positioning and automatic assembly into the transmission.
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/pizhou/pz1-6.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="text-box ">
                            <div class="title">
                                Gear Hot Press Fitting
                            </div>
                            <div class="destils">
                                The engine drive gear is heated by an AtecD medium-frequency induction heater under full digital precision control via DSP.
                                The equipment automatically picks up materials for high-precision press fitting, followed by air cooling to room temperature.
                                
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/pizhou/pz1-7.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="text-box ">
                            <div class="title">
                                DHT Hybrid Transmission Line
                            </div>
                            <div class="destils">
                                The DHT hybrid transmission line has an overall automation rate of 63% and error-proofing coverage of 100%. Designed with the philosophy of intelligence, digitalization and flexibility, the line is divided into five zones:
                                motor line, shaft & gear line, assembly line, test line and sub-assembly line. Featuring a rectangular overall layout with L-shaped assembly and L-shaped logistics, the line achieves agile, precise and efficient line operation and material distribution.
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/pizhou/pz1-8.jpg" alt="">
                        </div>
                    </div>

                </div>
                <div class="kv_pagination swiper-pagination left"></div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                DHT6 Line
            </div>
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/pizhou/pz2-1.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                EOL Test
                            </div>
                            <div class="destils">
                                ① Equipped with dedicated test benches to perform 100% full-function and performance testing. Automation rate: 100%, equipment availability rate: above 95%.<br />
                                ② Test items cover transmission self-learning, sensor function, shift function, parking function, clutch performance, NVH and drag torque.
                                  A real-time system analyzes test data for quality judgment.
                                  NVRAM data recording enables full life-cycle quality tracking and after-sales service, forming a complete quality control system for DHT automatic transmission<br />
                                ③ Test data is stored in a dedicated server to ensure full traceability. Dual-machine hot backup and SMTP are adopted to guarantee stable server operation.
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/pizhou/pz2-2.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                Motor Line Transfer & Clutch Housing Press Fitting
                            </div>
                            <div class="destils">
                                ① Realizes housing loading, 3D precise recognition and automatic gripping.<br />
                                ② Workstation operation: The robot automatically grasps the clutch housing from the material cart to the working position and completes automatic depalletizing.<br />
                                ③ Technology applied: 3D vision system + robots.<br />
                                ④ Technical highlights: 3D detection establishes the spatial coordinates of the workpiece. The robot grips accurately according to the coordinates and realizes depalletizing, which improves automation and reduces manual labor.
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/pizhou/pz2-3.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                Collaborative Robot Automatic Fastening
                            </div>
                            <div class="destils">
                                ① Adopts collaborative robots for automatic tightening.<br />
                                ② Workstation operation: Tightening of transmission components.<br />
                                ③ Technology applied: Automatic tightening with collaborative robots.<br />
                                ④ Technical highlights: Safe operation with human intervention permitted. Reduces the number of operators and lowers maintenance difficulty.
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/pizhou/pz2-4.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                Housing Measurement
                            </div>
                            <div class="destils">
                                ① Realizes automatic measurement of the housing and shaft system.<br />
                                ② Workstation operation: Measures height dimensions such as the housing bearing positions.<br />
                                ③ Technology applied: High-precision sensors (accuracy 0.001, resolution 0.0001), dynamic measurement for tapered roller bearings.<br />
                                ④ Technical highlights: Fully automatic station integrating housing and shaft measurement to ensure consistency with actual product status. Dynamic measurement further improves accuracy, and equipment repeatability meets Cg≥1.67.
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/pizhou/pz2-5.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                Shaft System Assembly 
                            </div>
                            <div class="destils">
                                ① Realizes shaft system assembly and installation into the transmission housing.<br />
                                ② Workstation operation: Automatic line transfer of the shaft system, completing assembly and installation into the housing.<br />
                                ③ Technology applied: Six-axis synchronous installation.<br />
                                ④ Technical highlights: Robotic handling, high positioning accuracy after assembly of shift forks, shafts and gears. The robot automatically completes the six-axis installation into the transmission.
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/pizhou/pz2-6.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                Housing Closing
                            </div>
                            <div class="destils">
                                ① Realizes transmission housing closing.<br />
                                ② Workstation operation: The robot grasps the motor sub-assembly and completes the clutch housing and transmission housing closing.<br />
                                ③ Technology applied: Automatic meshing.<br />
                                ④ Technical highlights: The robot loads the motor sub-assembly; the housing closing machine automatically rotates the motor shaft to complete spline meshing and clutch-transmission housing closing.
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/pizhou/pz2-7.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                Leak Testing
                            </div>
                            <div class="destils">
                                ① Adopts automatic assembly leak testing process.<br />
                                ② Workstation operation: Assembly leak testing.<br />
                                ③ Technology applied: Fully automatic plugging and testing.<br />
                                ④ Technical highlights: Fully automatic plugging and testing. Adopts international first-class brand leak testers, with repeatability precision Cg≥1.67.
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/pizhou/pz2-8.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                Assembly Appearance Inspection
                            </div>
                            <div class="destils">
                                ① Adopts camera-based appearance inspection.<br />
                                ② Workstation operation: Visual inspection of the assembly by camera.<br />
                                ③ Technology applied: Collaborative robot, vision inspection + dark room.<br />
                                ④ Technical highlights: Fully automatic appearance inspection to ensure product quality before delivery.
                            </div>
                        </div>
                    </div>

                </div>
                <div class="kv_pagination swiper-pagination"></div>
            </div>
        </div>



    </div>
    <Footer></Footer>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import $ from 'jquery';

// 存储所有swiper实例，方便销毁
const swiperInstances = ref([]);

// 初始化所有轮播的核心函数
const initAllSwipers = async () => {
    await nextTick();

    const swiperElements = document.querySelectorAll('.swiper-item');

    swiperElements.forEach(el => {
        if (el) {
            const swiper = new Swiper(el, {
                speed: 1300,
                pagination: {
                    el: el.querySelector(".swiper-pagination"), // 绑定当前容器内的分页器
                    clickable: true,
                },
                direction: "horizontal",
                slidesPerView: 1,
                // spaceBetween: 20,
                simulateTouch: true,
                effect: 'fade',
                breakpoints: {
                    768: {},
                    1024: {}
                },
                // navigation: {
                //     nextEl: el.querySelector(".btn-r"),
                //     prevEl: el.querySelector(".btn-l"),
                //     disabledClass: 'swiper-button-disabled',
                // },
                on: {
                    // init: function () {
                    //     console.log('轮播初始化完成');
                    // },
                    // slideChangeTransitionStart(swiper) {
                    //     let swiperIndex = swiper.realIndex;
                    //     console.log('当前轮播索引：', swiperIndex);
                    // },
                },
            });
            swiperInstances.value.push(swiper); // 保存实例
        }
    });
};

// 页面挂载时初始化轮播
onMounted(() => {
    initAllSwipers();
});

// 页面卸载时销毁轮播实例（防止内存泄漏）
onUnmounted(() => {
    swiperInstances.value.forEach(swiper => {
        swiper.destroy(true, true);
    });
    swiperInstances.value = [];
});
</script>

<script>
export const pageConfig = {
    title: 'Pizhou Transmission Plant - FINEST Website',
    keywords: 'FINEST,Engine,Transmission,Electronics',
    description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
    outputPath: 'en/manufacture/tr/pizhou.html'
};

import { createApp } from 'vue';
import App from './pizhou.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/manufacture-detail.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./pizhou.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss"></style>
